import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AuthCard from '../AuthCard/AuthCard';
import { PRICE_LINES, PRICING_URL } from '../../constants';
import './Landing.css';

const FEATURES = [
  'Every defect in the inspection report, with an estimated repair cost range',
  'Compliance flags, and the items that need a contractor to evaluate',
  'Local contractors matched to each repair',
  'A negotiation strategy for buyers and their agents, ready to share by email',
] as const;

/**
 * The public page at "/". It says what PropWise does without a sign-in,
 * because the payment provider's domain review refuses a site whose first
 * page is a login wall (task 28). AuthCard supplies the shell and the policy
 * links (Terms, Privacy, Refund) the review requires. A signed-in visitor
 * goes straight to their reports, as "/" did before.
 */
const Landing: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/reports" replace />;
  }

  return (
    <AuthCard
      title="Welcome to PropWise"
      subtitle="Upload a home inspection report and get a clear repair plan in minutes."
    >
      <ul className="landing-features">
        {FEATURES.map((feature) => (
          <li key={feature}>
            <i className="bi bi-check-circle-fill" aria-hidden="true"></i>
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <section className="landing-pricing" aria-labelledby="landing-pricing-heading">
        <h2 id="landing-pricing-heading">Pricing (USD)</h2>
        <ul>
          {PRICE_LINES.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </section>

      <Link to="/login" className="btn btn-primary btn-login">
        <i className="bi bi-box-arrow-in-right me-2"></i>
        Log in
      </Link>

      <div className="login-footer landing-footer">
        <div className="login-links">
          <Link to="/signup" className="login-link">Create an account</Link>
          <a href={PRICING_URL} className="login-link" target="_blank" rel="noopener noreferrer">
            Plans and pricing
          </a>
        </div>
      </div>
    </AuthCard>
  );
};

export default Landing;
